<template>
  <div>
    <el-form ref="form" :model="form" :rules="rules" label-width="auto">
      <el-row>
        <el-col :span="6" :push="2">
          <el-form-item prop="addWay" label="添加学员方式:">
            <el-radio v-model="form.addWay" label="1">单用户</el-radio>
            <el-radio v-model="form.addWay" label="2">批量导入</el-radio>
          </el-form-item>
        </el-col>
      </el-row>
      <el-divider border-style="dashed"></el-divider>
      <el-row style="padding: 25px 0">
        <el-col :span="8" :push="2">
          <el-form-item
            v-if="form.addWay === '1'"
            prop="uids"
            label="添加用户:"
          >
            <!-- <el-select
              v-model="form.uids"
              multiple
              filterable
              :multiple-limit="20"
              placeholder="请选择"
            >
              <el-option
                v-for="item in userList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select> -->
            <div v-if="selectUsers && selectUsers.length">
              <el-row v-for="(item, index) in selectUsers" :key="index">
                <el-col :span="22">
                  <el-input
                    :value="item.name"
                    size="small"
                    :disabled="true"
                    clearable
                  />
                </el-col>
                <el-col :span="2">
                  <el-button
                    type="danger"
                    icon="el-icon-delete"
                    circle
                    @click="handleDelete(index)"
                    size="small"
                    style="margin-top: 5px"
                  ></el-button>
                </el-col>
              </el-row>
            </div>
            <el-autocomplete
              v-model="userName"
              :fetch-suggestions="fetchSuggestions"
              value-key="name"
              clearable
              size="small"
              :select-when-unmatched="true"
              :trigger-on-focus="false"
              @select="selectUser"
            ></el-autocomplete>
            <div style="color: rgb(127, 127, 127)">
              可选择单个用户，最多支持选择100个用户
            </div>
          </el-form-item>

          <el-form-item
            v-if="form.addWay === '2'"
            prop="file"
            label="批量导入用户:"
          >
            <el-upload
              class="upload-demo"
              action=""
              :before-upload="beforeUpload"
              :before-remove="onRemove"
              :file-list="fileList"
              accept="application/vnd.ms-excel"
            >
              <el-button size="small" type="primary">选择文件</el-button>
              <div slot="tip" class="el-upload__tip">
                <span style="color: #aaa; margin-right: 8px">导入模板</span>
                <span style="color: #509eff; cursor: pointer" @click="download"
                  >点击下载</span
                >
              </div>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <div style="display: flex; justify-content: center; margin-top: 20px">
        <el-button
          type="primary"
          size="medium"
          style="width: 100px"
          @click="submit"
        >
          保存
        </el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import * as api from '@/api/ClassManagement/classStudent'
export default {
  props: {
    albumId: {
      type: String,
    },
  },
  data() {
    const validateFile = (rule, value, callback) => {
      console.log('validateFile', this.file)
      if (this.file) {
        callback()
      } else {
        callback(new Error('请选择文件'))
      }
    }
    const validateUser = (rule, value, callback) => {
      if (this.selectUsers.length == 0) {
        callback(new Error('用户不能为空'))
      } else {
        let ids = this.selectUsers.map((value) => value.id)
        let idsSet = new Set(ids)
        console.log('ids', ids, idsSet, idsSet.size, ids.length)
        if (idsSet.size == ids.length) {
          callback()
        } else {
          callback(new Error('用户不能重复'))
        }
      }
    }
    return {
      form: {
        addWay: '1',
        uids: '',
      },
      file: null,
      rules: {
        addWay: [{ required: true, trigger: 'blur' }],
        uids: [{ required: true, validator: validateUser, trigger: 'blur' }],
        file: [{ required: true, validator: validateFile, trigger: 'blur' }],
      },
      fileList: [],
      userList: [],
      selectUsers: [],
      userName: '',
    }
  },
  mounted() {
    console.log('albumId', this.albumId)
    this.getClassUser()
  },
  methods: {
    async fetchSuggestions(queryString, cb) {
      if (queryString && queryString.trim()) {
        const { code, data } = (
          await api.getClassUser({
            albumId: this.albumId,
            uname: queryString,
          })
        ).data
        if (code === 100000) {
          cb(data)
        } else {
          this.$message.error('系统繁忙')
        }
      }
      console.log('queryString', queryString)
    },
    selectUser(item) {
      console.log('item', item, this.userName, this.selectUsers)
      this.selectUsers.push(item)
      this.$refs.form.validateField('uids')
      this.userName = ''
    },
    handleDelete(index) {
      console.log('index', 1)
      this.selectUsers.splice(index, 1)
      this.$refs.form.validateField('uids')
    },
    async getClassUser() {
      const { code, data } = (await api.getClassUser({ albumId: this.albumId }))
        .data
      if (code === 100000) {
        this.userList = data
      } else {
        this.$message.error('系统繁忙')
      }
    },
    beforeUpload(file) {
      console.log('file', file)
      this.fileList = []
      this.fileList.push({ name: file.name })
      this.file = file
      return false
    },
    onRemove(file, fileList) {
      console.log(file, fileList, this.file)
      if (file.status === 'success') {
        this.fileList = []
        this.file = null
      }
      return true
    },
    download() {
      window.open(
        `${window.location.protocol}//${window.location.host}/group1/M00/FF/FF/img/模板/班级用户导入模板.xls`
      )
    },
    submit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let result = {}
          if (this.form.addWay === '1') {
            let uids = ''
            this.selectUsers.forEach((item) => {
              uids += item.id + ','
            })
            let reg = /,$/gi
            uids = uids.replace(reg, '')
            result = (await api.addClassUser({ uids, albumId: this.albumId }))
              .data
          } else {
            let formData = new FormData()
            formData.append('file', this.file)
            formData.append('albumId', this.albumId)
            result = (await api.importClassUser(formData)).data
          }
          console.log('code', result)
          if (result.code === 100000) {
            this.$message.success('添加成功')
            this.$emit('closeAddStudents')
          } else {
            this.$message.error(result.msg || '添加失败')
          }
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-autocomplete {
  width: 100%;
}
/deep/.el-form-item {
  margin-bottom: 0;
}
</style>